import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
const FaseA = () => {

  return (<>
    <PageHeader
    title="Fase A EFRAG"
    description="INDIVIDUAZIONE E SELEZIONE STAKEHOLDER E AMBITI DI INTERVENTO PER TIPOLOGIA"
    className="mb-3"
    >

    </PageHeader>
    
    <Card key="CRITERI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>Criteri</h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL01">
              <Link to="scheda-01">
                SCHEDA 1 – CRITERI PROPOSTA BASE STAKEHOLDER INTEGRATA CON LE NORME CSRD 
                <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
              </Link> 
            </li>
          <li key="ALL02">
            <Link to="scheda-02">
            SCHEDA 2 – CRITERI PROPOSTA BASE AMBITI DI IMPATTO (ALL. 2/1) E FINANZIARI (ALL. 2/2)
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>
          <li key="ALL03">
            <Link to="scheda-03">
              SCHEDA 3 – CRITERI ANALISI MATERIALITÀ E STRATEGICA AZIENDA PER LA SOSTENIBILITÀ 
              <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
            </Link> 
          </li>
          <li key="ALL04">
            <Link to="scheda-04">
              SCHEDA 4 – CRITERI ATTRIBUZIONE AMBITI ALLE TIPOLOGIE A, B, C 
              <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
            </Link> 
          </li>
          </ul>
          </Card.Text>
        </Card.Body>
      </Card>

      <Card key="SCHEMI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
          <h5 className="text-primary mb-0"  style={{marginBottom:"3%"}}><span className="text-info fw-medium">Schemi</span></h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL05">
              <Link to="scheda-05">
              SCHEDA 5 – SCHEMA SELEZIONE AZIENDALE DEGLI STAKEHOLDER PRINCIPALI 
              <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
            </Link> 
            </li>
            <li key="ALL06">
              <Link to="scheda-06">
                SCHEDA 6 – SCHEMA SELEZIONE AZIENDALE AMBITI DI INTERVENTO PRINCIPALI
                <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
              </Link> 
            </li>
            </ul>
          </Card.Text>
        </Card.Body>
      </Card>

    </>)
};

export default FaseA;
